angular.module('dpw.services')
    .factory('newFooterService', [function () {
        var self = this;

        var showOneTrust = function () {
            if (window.OneTrust) {
                window.OneTrust.ToggleInfoDisplay();
            } else {
                console.log('OneTrust is not ready');
            }

            return false;
        };

        self.iconLink = [
            {
                name: 'Facebook',
                href: 'https://www.facebook.com/ringcentral',
                icon: imgDirectory() + 'facebook.svg',
            },
            {
                name: 'Twitter',
                href: 'https://twitter.com/ringcentraldevs',
                icon: imgDirectory() + 'twitter.svg',
            },
            {
                name: 'LinkedIn',
                href: 'https://www.linkedin.com/company/ringcentral',
                icon: imgDirectory() + 'linkedin.svg',
            },
            {
                name: 'YouTube',
                href: 'https://www.youtube.com/ringcentral',
                icon: imgDirectory() + 'youtube.svg',
            },
            {
                name: 'Instagram',
                href: 'https://www.instagram.com/ringcentral',
                icon: imgDirectory() + 'instagram.svg',
            },
            {
                name: 'Tiktok',
                href: 'https://www.tiktok.com/@ringcentral',
                icon: imgDirectory() + 'tiktok.svg',
            },
        ];

        self.textLink = [
            {
                label: 'Legal',
                href: 'https://www.ringcentral.com/legal.html',
            },
            {
                label: 'Privacy',
                href: 'https://www.ringcentral.com/legal/privacy-notice.html',
            },
            {
                label: 'Cookie Notice',
                href: 'https://www.ringcentral.com/legal/cookie-notice.html',
            },
            {
                label: 'Site Map',
                href: 'https://www.ringcentral.com/sitemap.html',
            },
            {
                label: 'Accessibility',
                href: 'https://www.ringcentral.com/accessibility.html',
            },
            {
                label: 'Contact Us',
                href: 'https://www.ringcentral.com/whyringcentral/contactus.html',
            },
            {
                label: 'Cookie Preferences',
                href: '',
                onClick: showOneTrust,
            },
            {
                label: 'Do not sell or share my personal data',
                href: '',
                onClick: showOneTrust,
            },
        ];

        self.apiLink = '/api-products';
        self.resourcesLink = '/resources';
        self.footerNavigationGroup = [
            {
                title: 'APIs',
                content: [
                    {
                        label: RCDPW.RCProductName,
                        href: self.apiLink,
                    },
                    {
                        label: 'RingCX',
                        href: self.apiLink,
                    },
                    {
                        label: 'RingSense',
                        href: self.apiLink,
                    },
                    {
                        label: 'RingCentral Video',
                        href: self.apiLink,
                    },
                    {
                        label: 'RingCentral Events',
                        href: self.apiLink,
                    },
                    {
                        label: 'Contact Center',
                        href: self.apiLink,
                    },
                ]
            },
            {
                title: 'SOLUTIONS',
                content: [
                    {
                        label: 'Healthcare',
                        href: '/solutions/healthcare',
                    },
                    {
                        label: 'Finance',
                        href: '/solutions/financial-services',
                    },
                    {
                        label: 'Retail',
                        href: '/solutions/retail',
                    },
                    {
                        label: 'Education',
                        href: '/solutions/education',
                    },
                    {
                        label: 'View all',
                        href: '/solutions',
                    },
                ]
            },
            {
                title: 'PARTNERS',
                content: [
                    {
                        label: 'ISV Partner program',
                        href: 'https://www.ringcentral.com/partner/isv.html',
                    },
                    {
                        label: 'RingCentral Ventures',
                        href: 'https://www.ringcentral.com/ventures.html',
                    },
                    {
                        label: 'App Gallery',
                        href: 'https://www.ringcentral.com/apps',
                    },
                ]
            },
            {
                title: 'COMMUNITY',
                content: [
                    {
                        label: 'Game Changers',
                        href: RCDPW.entries.gameChangers.href,
                    },
                    {
                        label: 'Developer Forum',
                        href: RCDPW.goToCommunityUrl,
                        target: '_blank',
                    },
                    {
                        label: 'StackOverflow',
                        href: RCDPW.soUrl,
                    },
                    {
                        label: 'Events',
                        href: RCDPW.entries.developerEvents.href,
                    },
                    {
                        label: 'Blog',
                        href: RCDPW.blogUrl,
                    },
                ]
            },
            {
                title: 'RESOURCES',
                content: [
                    {
                        label: 'eBooks',
                        href: self.resourcesLink,
                    },
                    {
                        label: 'Videos',
                        href: self.resourcesLink,
                    },
                    {
                        label: 'Data sheets',
                        href: self.resourcesLink,
                    },
                    {
                        label: 'Whitepapers',
                        href: self.resourcesLink,
                    },
                ]
            },
            {
                title: 'SUPPORT',
                content: [
                    {
                        label: 'API status',
                        href: '/status',
                    },
                    {
                        label: 'Create a ticket',
                    },
                    {
                        label: 'View your tickets',
                    },
                ]
            },
        ];

        function imgDirectory() {
            return '/assets/images/footer/';
        }

        var footerMenus = {
            iconLink: self.iconLink,
            textLink: self.textLink,
            footerNavigationGroup: self.footerNavigationGroup,
        };

        return footerMenus;
    }]);
